







































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import FlotasMap from '@/pantallas/TorreControl/ControlFlotas/FlotasMap.vue';
import { LoadingService } from '@/services/loadingService';
import TorreControlInstance from '@/pantallas/TorreControl/comunes/Instances';

@Component({
  name: 'FlotasCarousel',
  components: {
    FlotasMap,
  },
})
export default class FlotasCarousel extends Vue {
  @Prop({ default: true }) show!: boolean;
  @Prop({ default: [] }) elementos!: any;
  @Prop({ default: [] }) elementos2!: any;
  @Prop({ default: () => ({}) }) clientData!: any;
  loadingService = new LoadingService();
  flotaActual: number = 0;
  cantidadVehiculos: number = 0;
  nameTitle: string = 'Flota';
  activeElement: number = 0;
  botonPresionado: number | null = null;

  beforeDestroy() {
    this.elementos = [];
    TorreControlInstance.$off('showCount');
  }

  mounted() {
    TorreControlInstance.$on('showCount', (cantidad: number) => {
      this.cantidadVehiculos = cantidad;
    });
  }
  onEvent(e: any) {
    this.activeElement = e;
    this.flotaActual = this.elementos[e].cod_flota;
    this.cantidadVehiculos = 0;
    this.botonPresionado = e;
    TorreControlInstance.$emit('changeSlide');
  }
  onClick(i: number) {
    if (this.activeElement == i) return;
    this.botonPresionado = i;
    this.onEvent(i);
  }

  @Watch('clientData')
  checkCustom() {
    if (this.clientData != null) {
      if (this.clientData.active_custom) {
        this.nameTitle = this.clientData.name_custom;
      }
    }
  }

  @Watch('elementos')
  onElementosChange(newVal: any, oldVal: any) {
    if (newVal.length > 0) {
      this.onEvent(0);
    }
  }
}
